module.exports = __webpack_public_path__ + "img/picture12.b5ccb0d3.png";